import {createContext} from 'react';
import {QuestionContextType} from './types';

export const QuestionContext = createContext<QuestionContextType | null>(null);

export const QuestionContextProvider = QuestionContext.Provider;
